var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoAtlas64 = function SvgLogoAtlas64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 60,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 24v6H7a7 7 0 0 0-7 7v4a7 7 0 0 0 7 7h1v5a7 7 0 0 0 7 7h4a7 7 0 0 0 7-7v-5h12v5a7 7 0 0 0 7 7h4a7 7 0 0 0 7-7v-5h1a7 7 0 0 0 7-7v-4a7 7 0 0 0-7-7h-1v-6C56 10.745 45.255 0 32 0S8 10.745 8 24m24-6a6 6 0 0 0-6 6v6h12v-6a6 6 0 0 0-6-6m-12 6v6h-6v-6c0-9.941 8.059-18 18-18s18 8.059 18 18v6h-6v-6c0-6.627-5.373-12-12-12s-12 5.373-12 12m37 12a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zM14 53v-5h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1m30 0v-5h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgLogoAtlas64;